import { render, staticRenderFns } from "./chooseCoupon.vue?vue&type=template&id=0b20319f&scoped=true&"
import script from "./chooseCoupon.vue?vue&type=script&lang=js&"
export * from "./chooseCoupon.vue?vue&type=script&lang=js&"
import style0 from "./chooseCoupon.vue?vue&type=style&index=0&id=0b20319f&prod&lang=css&"
import style1 from "./chooseCoupon.vue?vue&type=style&index=1&id=0b20319f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b20319f",
  null
  
)

export default component.exports